import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b1c8e31c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b1c8e31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c8e31c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c8e31c')) {
      api.createRecord('b1c8e31c', component.options)
    } else {
      api.reload('b1c8e31c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b1c8e31c&scoped=true&", function () {
      api.rerender('b1c8e31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4CeaWegSqLq1y/JS/comp/Voucher.vue"
export default component.exports